import * as React from "react";

export function ActionButton({ 
    variant = 'submit',
    text = 'btn',
    handleSubmit = () => {}, 
    onClick,
    disabled = false,
    isSubmit,
    type,
    icon
}) {

    const buttonStyles = {
        reset: "overflow-hidden gap-2.5 self-stretch px-5 py-1.5 my-auto rounded-md font-semibold bg-navBtn hover:bg-white text-zinc-600  border-2 border-navBtn text-base",
        cancel: "overflow-hidden gap-2.5 self-stretch px-5 py-1.5 my-auto text-black font-semibold bg-white hover:bg-navBtn rounded-md border-2 border-primary border-solid text-base",
        submit: "overflow-hidden gap-2.5 self-stretch px-5 py-1.5 my-auto text-white font-bold bg-primary hover:bg-primaryHoverDark rounded-md border-2 border-solid border-primary text-base",
        prev: "overflow-hidden gap-2.5 self-stretch px-5 py-1.5 my-auto text-white font-bold bg-primary hover:bg-primaryHoverDark rounded-md border-2 border-solid border-primary text-base",
        next: "overflow-hidden gap-2.5 self-stretch px-5 py-1.5 my-auto text-white font-bold bg-primary hover:bg-primaryHoverDark rounded-md border-2 border-solid border-primary text-base",
        white: "overflow-hidden gap-2.5 self-stretch px-5 py-1.5 my-auto text-black font-semibold bg-white hover:bg-navBtn rounded-md  border border-solid border-primary text-base",
        primary: "overflow-hidden gap-2.5 self-stretch px-5 py-1.5 my-auto text-white font-bold bg-primary hover:bg-primaryHoverDark rounded-md border-2 border-solid border-primary text-base",
        secondary: "overflow-hidden gap-2.5 self-stretch px-5 py-1.5 my-auto text-black font-semibold bg-white hover:bg-navBtn rounded-md border-2 border-primary border-solid text-base",
        danger: "overflow-hidden gap-2.5 self-stretch px-5 py-1.5 my-auto text-white font-bold bg-red hover:bg-hoverRed rounded-md border-2 border-solid border-red text-base",
    };

    const buttonType = type || ((variant === "submit" || isSubmit === true) ? "submit" : "button");
    const clickHandler = onClick || handleSubmit;

    return (
        <button
            type={buttonType}
            className={`${buttonStyles[variant]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} flex items-center justify-center`}
            onClick={clickHandler}
            disabled={disabled}
        >
            {icon && <span className="mr-2">{icon}</span>}
            {text}
        </button>
    );
}